import { CustomTheme } from './theme.types'
import { skyCenterPrimaryPalette } from './conts'

const theme = (): CustomTheme => {
    return { typography: {
        h1: {
            fontSize: 36,
            fontWeight: 200,
            lineHeight: '43px',
            color: skyCenterPrimaryPalette.white,
        },
        h3: {
            fontSize: 24,
            fontWeight: 400,
            letterSpacing: 0.3,
            lineHeight: '29px',
            color: skyCenterPrimaryPalette.h3,
        },
        h5: {
            fontSize: 20,
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: 0.62,
            color: skyCenterPrimaryPalette.h5,
        },
    } }
}

export default theme
